module.exports = __webpack_public_path__ + "static/media/attachment.9a549224.svg";